module.exports = __webpack_public_path__ + "img/dog_scratching_icon_v2.0e8e2f49.svg";